import { isInIframe } from "@utils/window";
import useLanguage from "./useLanguage";

/**
 * 平台重定向 hooks
 * 用于处理其他平台（非 kalodata）的登录/注册后重定向逻辑
 */
export const usePlatformRedirect = () => {
  // 使用全局语言 hooks 获取当前语言
  const { language } = useLanguage();

  /**
   * 从 URL 参数中获取 bizCode 和 redirectUrl
   */
  const getPlatformParams = () => {
    const params = new URLSearchParams(window.location.search);
    const bizCode = params.get("bizCode");
    const redirectUrl = params.get("redirectUrl");
    return { bizCode, redirectUrl };
  };

  /**
   * 在 URL 中添加语言参数
   */
  const appendLanguageToUrl = (url: string, language: string): string => {
    if (!url || !language) return url;

    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set("language", language);
      return urlObj.toString();
    } catch (error) {
      // 如果 URL 解析失败（可能是相对路径），手动拼接
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}language=${encodeURIComponent(language)}`;
    }
  };

  /**
   * 执行第三方平台重定向
   */
  const redirectToPlatform = () => {
    const { bizCode, redirectUrl } = getPlatformParams();

    if (bizCode) {
      // 发送 postMessage 通知父窗口登录成功
      try {
        const message = {
          type: "LOGIN_SUCCESS",
          bizCode,
          redirectUrl,
        };
        if (isInIframe()) {
          // 在 iframe 中，通知父窗口
          window.parent.postMessage(message, "*");
        } else if (window.opener && !window.opener.closed) {
          // 在弹出窗口中，通知 opener
          window.opener.postMessage(message, "*");
        } else {
          window.postMessage(message, "*");
        }
      } catch (error) {
        console.error("发送 postMessage 失败:", error);
      }

      // 非 kalodata 平台登录回跳，跳转到 redirectUrl 地址，携带语言参数
      if (redirectUrl) {
        const finalUrl = appendLanguageToUrl(redirectUrl, language);
        window.location.href = finalUrl;
      }
      return true;
    }

    return false;
  };

  return {
    getPlatformParams,
    redirectToPlatform,
  };
};
